// extracted by mini-css-extract-plugin
module.exports = {"standardStack":"sku-detail-page_standardStack__BJyXU","labStack":"sku-detail-page_labStack__GLB8S"};